// extracted by mini-css-extract-plugin
module.exports = {"counter":"counter-module--counter--1u3BW"};